import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import EditPhoneModal from "@/shared/components/channels/EditPhoneModal.vue";
import { updateOrganisationCommunicationChannel } from "../../infrastructure/api/organisationApi";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganisationEditPhoneModal',
    props: /*@__PURE__*/ _mergeModels({
        organisationId: {},
        channelId: {},
        initialValue: {},
        initialIsPrimary: { type: Boolean },
        initialSubType: {}
    }, {
        "modelValue": { type: Boolean, ...{ default: false } },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["updated", "delete"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const props = __props;
        const open = _useModel(__props, "modelValue");
        const emit = __emit;
        const ERROR_OVERRIDES = {
            'CommunicationChannel.Phone.Invalid': 'organisation.detail.addPhone.errors.phoneInvalid',
        };
        function submitPhone(payload) {
            return updateOrganisationCommunicationChannel(props.organisationId, props.channelId, {
                type: "Phone",
                value: payload.value,
                isPrimary: payload.isPrimary,
                subType: payload.subType,
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(EditPhoneModal, {
                modelValue: open.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((open).value = $event)),
                "initial-value": __props.initialValue,
                "initial-is-primary": __props.initialIsPrimary,
                "initial-sub-type": __props.initialSubType,
                submit: submitPhone,
                "error-overrides": ERROR_OVERRIDES,
                "i18n-prefix": "organisation.detail.editPhone",
                "field-i18n-prefix": "organisation.detail.addPhone",
                onUpdated: _cache[1] || (_cache[1] = ($event) => (emit('updated'))),
                onDelete: _cache[2] || (_cache[2] = ($event) => (emit('delete')))
            }, null, 8 /* PROPS */, ["modelValue", "initial-value", "initial-is-primary", "initial-sub-type"]));
        };
    }
});
